// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-grid-layout {
    width: 100%;
    height: 100%;
    margin-left: -30px;
    margin-top: -10px;
    display: flex;
    flex-direction: column;
}

.up-feed-container {
    height: 600px;
    background: none;
    margin-left: 100px;
    margin-top: 10px;
}

.up-user-feed {
    margin-bottom: 30px;
    border-radius: 20px;
    box-shadow: 0px 0px 1px white;
}

.up-user-container {
    display: flex;
    align-items: left;
    gap: 15px;
    padding-bottom: 10px;
}

.up-user-images {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    margin-top: 10px;
    margin-left: 10px;
}

.up-post-card {
    margin-top: 15px;
    margin-left: 65px;
    padding: 10px;
    box-shadow: "0px 0px 1px rgba(255,255,255,0.2)";
    border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/UserPickFeedData.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,+CAA+C;IAC/C,kBAAkB;AACtB","sourcesContent":[".up-grid-layout {\n    width: 100%;\n    height: 100%;\n    margin-left: -30px;\n    margin-top: -10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.up-feed-container {\n    height: 600px;\n    background: none;\n    margin-left: 100px;\n    margin-top: 10px;\n}\n\n.up-user-feed {\n    margin-bottom: 30px;\n    border-radius: 20px;\n    box-shadow: 0px 0px 1px white;\n}\n\n.up-user-container {\n    display: flex;\n    align-items: left;\n    gap: 15px;\n    padding-bottom: 10px;\n}\n\n.up-user-images {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-top: 10px;\n    margin-left: 10px;\n}\n\n.up-post-card {\n    margin-top: 15px;\n    margin-left: 65px;\n    padding: 10px;\n    box-shadow: \"0px 0px 1px rgba(255,255,255,0.2)\";\n    border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
